<app-dialog class="add-list-tree-dialog">
  <ng-container dialog-title>
    {{ title }}
  </ng-container>

  <ng-container dialog-content>
    <app-list-tree #listTree [data]="treeData" [itemSize]="20" [searchPlaceholder]="'Suche'" [multiple]="true"></app-list-tree>
  </ng-container>

  <ng-container dialog-actions>
    <button class="btn btn-outline-primary" (click)="cancel()">
      {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.cancel' | translate }}
    </button>
    <button class="btn btn-outline-primary" (click)="save()">
      {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.save' | translate }}
    </button>
  </ng-container>
</app-dialog>
